{
  "items": [
    {
      "city": "Minsk",
      "lat": "53.9022",
      "lng": "27.5618",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minsk",
      "capital": "primary",
      "population": "2009786",
      "population_proper": "2009786"
    },
    {
      "city": "Homyel’",
      "lat": "52.4417",
      "lng": "30.9833",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "admin",
      "population": "510300",
      "population_proper": "510300"
    },
    {
      "city": "Vitsyebsk",
      "lat": "55.1833",
      "lng": "30.1667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "admin",
      "population": "364800",
      "population_proper": "364800"
    },
    {
      "city": "Mahilyow",
      "lat": "53.9089",
      "lng": "30.3430",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "admin",
      "population": "357100",
      "population_proper": "357100"
    },
    {
      "city": "Hrodna",
      "lat": "53.6667",
      "lng": "23.8167",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "admin",
      "population": "356900",
      "population_proper": "356900"
    },
    {
      "city": "Brest",
      "lat": "52.0847",
      "lng": "23.6569",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "admin",
      "population": "340318",
      "population_proper": "340318"
    },
    {
      "city": "Babruysk",
      "lat": "53.1500",
      "lng": "29.2333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "212200",
      "population_proper": "212200"
    },
    {
      "city": "Baranavichy",
      "lat": "53.1167",
      "lng": "25.9833",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "174183",
      "population_proper": "174183"
    },
    {
      "city": "Horad Barysaw",
      "lat": "54.2260",
      "lng": "28.4922",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "155389",
      "population_proper": "100000"
    },
    {
      "city": "Pinsk",
      "lat": "52.1153",
      "lng": "26.1031",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "125900",
      "population_proper": "125900"
    },
    {
      "city": "Orsha",
      "lat": "54.5092",
      "lng": "30.4258",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "106505",
      "population_proper": "106505"
    },
    {
      "city": "Mazyr",
      "lat": "52.0500",
      "lng": "29.2333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "105439",
      "population_proper": "105439"
    },
    {
      "city": "Lida",
      "lat": "53.8872",
      "lng": "25.3028",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "",
      "population": "103391",
      "population_proper": "103391"
    },
    {
      "city": "Salihorsk",
      "lat": "52.7842",
      "lng": "27.5425",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "100824",
      "population_proper": "100824"
    },
    {
      "city": "Navapolatsk",
      "lat": "55.5333",
      "lng": "28.6667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "",
      "population": "98122",
      "population_proper": "98122"
    },
    {
      "city": "Maladzyechna",
      "lat": "54.3136",
      "lng": "26.8517",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "91063",
      "population_proper": "91063"
    },
    {
      "city": "Polatsk",
      "lat": "55.4833",
      "lng": "28.8000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "80795",
      "population_proper": "80795"
    },
    {
      "city": "Svyetlahorsk",
      "lat": "52.6333",
      "lng": "29.7333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "64989",
      "population_proper": "64989"
    },
    {
      "city": "Slutsk",
      "lat": "53.0167",
      "lng": "27.5500",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "61396",
      "population_proper": "61396"
    },
    {
      "city": "Kobryn",
      "lat": "52.2167",
      "lng": "24.3667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "52843",
      "population_proper": "52843"
    },
    {
      "city": "Slonim",
      "lat": "53.0833",
      "lng": "25.3167",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "49830",
      "population_proper": "49830"
    },
    {
      "city": "Vawkavysk",
      "lat": "53.1667",
      "lng": "24.4667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "42746",
      "population_proper": "42746"
    },
    {
      "city": "Kalinkavichy",
      "lat": "52.1333",
      "lng": "29.3333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "37633",
      "population_proper": "37633"
    },
    {
      "city": "Smarhon’",
      "lat": "54.4836",
      "lng": "26.4000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "36202",
      "population_proper": "36202"
    },
    {
      "city": "Horki",
      "lat": "54.2833",
      "lng": "30.9833",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "30390",
      "population_proper": "30390"
    },
    {
      "city": "Asipovichy",
      "lat": "53.3000",
      "lng": "28.6500",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "29981",
      "population_proper": "29981"
    },
    {
      "city": "Dzyarzhynsk",
      "lat": "53.6833",
      "lng": "27.1333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "",
      "population": "29739",
      "population_proper": "29739"
    },
    {
      "city": "Byaroza",
      "lat": "52.5500",
      "lng": "24.9667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "28619",
      "population_proper": "28619"
    },
    {
      "city": "Navahrudak",
      "lat": "53.5833",
      "lng": "25.8167",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "",
      "population": "28199",
      "population_proper": "28199"
    },
    {
      "city": "Vilyeyka",
      "lat": "54.4833",
      "lng": "26.9167",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "27167",
      "population_proper": "27167"
    },
    {
      "city": "Krychaw",
      "lat": "53.7194",
      "lng": "31.7139",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "24170",
      "population_proper": "24170"
    },
    {
      "city": "Luninyets",
      "lat": "52.2500",
      "lng": "26.8000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "23734",
      "population_proper": "23734"
    },
    {
      "city": "Mar’’ina Horka",
      "lat": "53.5167",
      "lng": "28.1417",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "",
      "population": "20592",
      "population_proper": "20592"
    },
    {
      "city": "Pastavy",
      "lat": "55.1167",
      "lng": "26.8333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "19153",
      "population_proper": "19153"
    },
    {
      "city": "Pruzhany",
      "lat": "52.5567",
      "lng": "24.4644",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "19032",
      "population_proper": "19032"
    },
    {
      "city": "Dobrush",
      "lat": "52.4167",
      "lng": "31.3167",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "18311",
      "population_proper": "18311"
    },
    {
      "city": "Hlybokaye",
      "lat": "55.1333",
      "lng": "27.6833",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "17790",
      "population_proper": "17790"
    },
    {
      "city": "Zaslawye",
      "lat": "54.0000",
      "lng": "27.2833",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "",
      "population": "17701",
      "population_proper": "17701"
    },
    {
      "city": "Fanipal’",
      "lat": "53.7500",
      "lng": "27.3333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "",
      "population": "17507",
      "population_proper": "17507"
    },
    {
      "city": "Stowbtsy",
      "lat": "53.4833",
      "lng": "26.7333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "",
      "population": "17420",
      "population_proper": "17420"
    },
    {
      "city": "Ashmyany",
      "lat": "54.4250",
      "lng": "25.9375",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "16966",
      "population_proper": "16966"
    },
    {
      "city": "Ivanava",
      "lat": "52.1333",
      "lng": "25.5500",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "16498",
      "population_proper": "16498"
    },
    {
      "city": "Klimavichy",
      "lat": "53.6167",
      "lng": "31.9500",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "15408",
      "population_proper": "15408"
    },
    {
      "city": "Lahoysk",
      "lat": "54.2000",
      "lng": "27.8500",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "15336",
      "population_proper": "15336"
    },
    {
      "city": "Masty",
      "lat": "53.4000",
      "lng": "24.5333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "15197",
      "population_proper": "15197"
    },
    {
      "city": "Drahichyn",
      "lat": "52.1833",
      "lng": "25.1500",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "14963",
      "population_proper": "14963"
    },
    {
      "city": "Astravyets",
      "lat": "54.6136",
      "lng": "25.9553",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "14147",
      "population_proper": "14147"
    },
    {
      "city": "Khoyniki",
      "lat": "51.9000",
      "lng": "29.9667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "13439",
      "population_proper": "13439"
    },
    {
      "city": "Stolin",
      "lat": "51.8897",
      "lng": "26.8507",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "13038",
      "population_proper": "13038"
    },
    {
      "city": "Malaryta",
      "lat": "51.7972",
      "lng": "24.0808",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "12883",
      "population_proper": "12883"
    },
    {
      "city": "Mikashevichy",
      "lat": "52.2167",
      "lng": "27.4667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "12771",
      "population_proper": "12771"
    },
    {
      "city": "Novalukoml’",
      "lat": "54.6658",
      "lng": "29.1547",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "",
      "population": "12439",
      "population_proper": "12439"
    },
    {
      "city": "Haradok",
      "lat": "55.4667",
      "lng": "29.9833",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "11814",
      "population_proper": "11814"
    },
    {
      "city": "Lyuban’",
      "lat": "52.7819",
      "lng": "28.0525",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "11654",
      "population_proper": "11654"
    },
    {
      "city": "Klyetsk",
      "lat": "53.0636",
      "lng": "26.6372",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "11462",
      "population_proper": "11462"
    },
    {
      "city": "Byerazino",
      "lat": "53.8333",
      "lng": "28.9833",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "",
      "population": "11450",
      "population_proper": "11450"
    },
    {
      "city": "Staryya Darohi",
      "lat": "53.0394",
      "lng": "28.2650",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "11198",
      "population_proper": "11198"
    },
    {
      "city": "Byelaazyorsk",
      "lat": "52.4500",
      "lng": "25.1667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "11115",
      "population_proper": "11115"
    },
    {
      "city": "Uzda",
      "lat": "53.4661",
      "lng": "27.2244",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "",
      "population": "10781",
      "population_proper": "10781"
    },
    {
      "city": "Baran’",
      "lat": "54.4833",
      "lng": "30.3333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "",
      "population": "10573",
      "population_proper": "10573"
    },
    {
      "city": "Kapyl’",
      "lat": "53.1500",
      "lng": "27.0917",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "10367",
      "population_proper": "10367"
    },
    {
      "city": "Mstsislaw",
      "lat": "54.0196",
      "lng": "31.7247",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "10201",
      "population_proper": "10201"
    },
    {
      "city": "Skidal’",
      "lat": "53.5833",
      "lng": "24.2500",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "",
      "population": "10168",
      "population_proper": "10168"
    },
    {
      "city": "Byarozawka",
      "lat": "53.7167",
      "lng": "25.5000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "",
      "population": "10081",
      "population_proper": "10081"
    },
    {
      "city": "Valozhyn",
      "lat": "54.0833",
      "lng": "26.5167",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "10012",
      "population_proper": "10012"
    },
    {
      "city": "Pyetrykaw",
      "lat": "52.1333",
      "lng": "28.5000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "9986",
      "population_proper": "9986"
    },
    {
      "city": "Byalynichy",
      "lat": "53.9956",
      "lng": "29.7096",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "9913",
      "population_proper": "9913"
    },
    {
      "city": "Talachyn",
      "lat": "54.4167",
      "lng": "29.7000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "9899",
      "population_proper": "9899"
    },
    {
      "city": "Braslaw",
      "lat": "55.6397",
      "lng": "27.0397",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "9390",
      "population_proper": "9390"
    },
    {
      "city": "Buda-Kashalyova",
      "lat": "52.7167",
      "lng": "30.5667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "8850",
      "population_proper": "8850"
    },
    {
      "city": "Krupki",
      "lat": "54.3250",
      "lng": "29.1361",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "8540",
      "population_proper": "8540"
    },
    {
      "city": "Vyetka",
      "lat": "52.5592",
      "lng": "31.1808",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "8426",
      "population_proper": "8426"
    },
    {
      "city": "Narowlya",
      "lat": "51.8000",
      "lng": "29.5000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "8364",
      "population_proper": "8364"
    },
    {
      "city": "Kamyanyets",
      "lat": "52.4028",
      "lng": "23.8083",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "8349",
      "population_proper": "8349"
    },
    {
      "city": "Kirawsk",
      "lat": "53.2686",
      "lng": "29.4736",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "8178",
      "population_proper": "8178"
    },
    {
      "city": "Dzyatlava",
      "lat": "53.4500",
      "lng": "25.4000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "",
      "population": "8061",
      "population_proper": "8061"
    },
    {
      "city": "Slawharad",
      "lat": "53.4453",
      "lng": "30.9964",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "7928",
      "population_proper": "7928"
    },
    {
      "city": "Cherykaw",
      "lat": "53.5667",
      "lng": "31.3667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "7910",
      "population_proper": "7910"
    },
    {
      "city": "Myory",
      "lat": "55.6167",
      "lng": "27.6167",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "7845",
      "population_proper": "7845"
    },
    {
      "city": "Kruhlaye",
      "lat": "54.2479",
      "lng": "29.7966",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "7530",
      "population_proper": "7530"
    },
    {
      "city": "Syanno",
      "lat": "54.8000",
      "lng": "29.7000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "",
      "population": "7370",
      "population_proper": "7370"
    },
    {
      "city": "Iwye",
      "lat": "53.9307",
      "lng": "25.7703",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "",
      "population": "7329",
      "population_proper": "7329"
    },
    {
      "city": "Klichaw",
      "lat": "53.4828",
      "lng": "29.3411",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "7308",
      "population_proper": "7308"
    },
    {
      "city": "Myadzyel",
      "lat": "54.8756",
      "lng": "26.9386",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "7146",
      "population_proper": "7146"
    },
    {
      "city": "Vyerkhnyadzvinsk",
      "lat": "55.7667",
      "lng": "27.9333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "6956",
      "population_proper": "6956"
    },
    {
      "city": "Dubrowna",
      "lat": "54.5667",
      "lng": "30.6833",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "6951",
      "population_proper": "6951"
    },
    {
      "city": "Svislach",
      "lat": "53.0333",
      "lng": "24.1000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "6323",
      "population_proper": "6323"
    },
    {
      "city": "Davyd-Haradok",
      "lat": "52.0556",
      "lng": "27.2139",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "5919",
      "population_proper": "5919"
    },
    {
      "city": "Vysokaye",
      "lat": "52.3667",
      "lng": "23.3667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "4859",
      "population_proper": "4859"
    },
    {
      "city": "Azyershchyna",
      "lat": "52.4003",
      "lng": "30.3375",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "4707",
      "population_proper": "4707"
    },
    {
      "city": "Kozyenki",
      "lat": "52.0208",
      "lng": "29.1881",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "3862",
      "population_proper": "3862"
    },
    {
      "city": "Vasilyevichy",
      "lat": "52.2667",
      "lng": "29.8000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "3435",
      "population_proper": "3435"
    },
    {
      "city": "Turaw",
      "lat": "52.0692",
      "lng": "27.7361",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "2772",
      "population_proper": "2772"
    },
    {
      "city": "Hlushkavichy",
      "lat": "51.5714",
      "lng": "27.7739",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "2500",
      "population_proper": "2500"
    },
    {
      "city": "Babrovichy",
      "lat": "52.2917",
      "lng": "29.3728",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "2338",
      "population_proper": "2338"
    },
    {
      "city": "Vyalikiya Chuchavichy",
      "lat": "52.5833",
      "lng": "26.8500",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "2048",
      "population_proper": "2048"
    },
    {
      "city": "Novy Svyerzhan’",
      "lat": "53.4500",
      "lng": "26.7333",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "",
      "population": "1982",
      "population_proper": "1982"
    },
    {
      "city": "Kosava",
      "lat": "52.7580",
      "lng": "25.1529",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "1919",
      "population_proper": "1919"
    },
    {
      "city": "Vyalikiya Lyepyasy",
      "lat": "52.2500",
      "lng": "24.3667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "1613",
      "population_proper": "1613"
    },
    {
      "city": "Haradnaya",
      "lat": "51.8699",
      "lng": "26.4998",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "1587",
      "population_proper": "1587"
    },
    {
      "city": "Ramanavichy",
      "lat": "52.4269",
      "lng": "31.1233",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "1510",
      "population_proper": "1510"
    },
    {
      "city": "Dzisna",
      "lat": "55.5628",
      "lng": "28.2258",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "",
      "population": "1492",
      "population_proper": "1492"
    },
    {
      "city": "Novaya Mysh",
      "lat": "53.1333",
      "lng": "25.9000",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "1370",
      "population_proper": "1370"
    },
    {
      "city": "Akhremawtsy",
      "lat": "55.5808",
      "lng": "27.1078",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "",
      "population": "1312",
      "population_proper": "1312"
    },
    {
      "city": "Lakhva",
      "lat": "52.2183",
      "lng": "27.0958",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "1286",
      "population_proper": "1286"
    },
    {
      "city": "Khal’ch",
      "lat": "52.5622",
      "lng": "31.1422",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "1285",
      "population_proper": "1285"
    },
    {
      "city": "Nasilava",
      "lat": "54.3094",
      "lng": "26.7789",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "",
      "population": "1279",
      "population_proper": "1279"
    },
    {
      "city": "Kavyerdzyaki",
      "lat": "52.1772",
      "lng": "23.6692",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "1273",
      "population_proper": "1273"
    },
    {
      "city": "Haradzyets",
      "lat": "52.1833",
      "lng": "24.6667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "1272",
      "population_proper": "1272"
    },
    {
      "city": "Uza",
      "lat": "52.6006",
      "lng": "30.8178",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "1257",
      "population_proper": "1257"
    },
    {
      "city": "Salonaye",
      "lat": "52.8442",
      "lng": "30.0103",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "1169",
      "population_proper": "1169"
    },
    {
      "city": "Al’khowka",
      "lat": "54.8069",
      "lng": "26.2325",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "",
      "population": "1160",
      "population_proper": "1160"
    },
    {
      "city": "Bronnaye",
      "lat": "52.3158",
      "lng": "30.4794",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "1148",
      "population_proper": "1148"
    },
    {
      "city": "Rudnya",
      "lat": "51.8917",
      "lng": "29.2056",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "1116",
      "population_proper": "1116"
    },
    {
      "city": "Andreyewshchyna",
      "lat": "54.5672",
      "lng": "30.4522",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "",
      "population": "1091",
      "population_proper": "1091"
    },
    {
      "city": "Yakimovskaya Sloboda",
      "lat": "52.6222",
      "lng": "29.8286",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "",
      "population": "1057",
      "population_proper": "1057"
    },
    {
      "city": "Tsishowka",
      "lat": "53.8909",
      "lng": "30.2513",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "",
      "population": "1052",
      "population_proper": "1052"
    },
    {
      "city": "Lyubashava",
      "lat": "52.7828",
      "lng": "26.4233",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "",
      "population": "1042",
      "population_proper": "1042"
    },
    {
      "city": "Horad Zhodzina",
      "lat": "54.0985",
      "lng": "28.3331",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Horad Pinsk",
      "lat": "52.1214",
      "lng": "26.0728",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Horad Smalyavichy",
      "lat": "54.0249",
      "lng": "28.0894",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Zhlobin",
      "lat": "52.8926",
      "lng": "30.0240",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Nyasvizh",
      "lat": "53.2189",
      "lng": "26.6779",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Minskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Horad Krychaw",
      "lat": "53.6989",
      "lng": "31.7142",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Horad Kobryn",
      "lat": "52.2161",
      "lng": "24.3664",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Horad Rechytsa",
      "lat": "52.3639",
      "lng": "30.3947",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Rechytsa",
      "lat": "52.3617",
      "lng": "30.3916",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Zhabinka",
      "lat": "52.1976",
      "lng": "24.0069",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Rahachow",
      "lat": "53.0934",
      "lng": "30.0495",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Horad Luninyets",
      "lat": "52.2503",
      "lng": "26.7994",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Vyalikaya Byerastavitsa",
      "lat": "53.1960",
      "lng": "24.0166",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Chashniki",
      "lat": "54.8584",
      "lng": "29.1608",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Shchuchyn",
      "lat": "53.6014",
      "lng": "24.7465",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Lyakhavichy",
      "lat": "53.0388",
      "lng": "26.2656",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Voranava",
      "lat": "54.1492",
      "lng": "25.3112",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Hrodzyenskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Ivatsevichy",
      "lat": "52.7090",
      "lng": "25.3401",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Hantsavichy",
      "lat": "52.7580",
      "lng": "26.4300",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Brestskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Drybin",
      "lat": "54.1192",
      "lng": "31.0939",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Shklow",
      "lat": "54.2131",
      "lng": "30.2877",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Horad Orsha",
      "lat": "54.5153",
      "lng": "30.4053",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Kastsyukovichy",
      "lat": "53.3525",
      "lng": "32.0514",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Karma",
      "lat": "53.1301",
      "lng": "30.8016",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Sharkawshchyna",
      "lat": "55.3689",
      "lng": "27.4686",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Bykhaw",
      "lat": "53.5210",
      "lng": "30.2454",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Chachersk",
      "lat": "52.9164",
      "lng": "30.9179",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Zhytkavichy",
      "lat": "52.2168",
      "lng": "27.8561",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Loyew",
      "lat": "51.9458",
      "lng": "30.7953",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Khotsimsk",
      "lat": "53.4086",
      "lng": "32.5780",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Chavusy",
      "lat": "53.8098",
      "lng": "30.9717",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Yel’sk",
      "lat": "51.8141",
      "lng": "29.1522",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Lyozna",
      "lat": "55.0247",
      "lng": "30.7970",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Hlusk",
      "lat": "52.9030",
      "lng": "28.6845",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Dokshytsy",
      "lat": "54.8918",
      "lng": "27.7667",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Aktsyabrski",
      "lat": "52.6440",
      "lng": "28.8801",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Krasnapollye",
      "lat": "53.3353",
      "lng": "31.3999",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Mahilyowskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Lyel’chytsy",
      "lat": "51.7862",
      "lng": "28.3288",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Brahin",
      "lat": "51.7870",
      "lng": "30.2677",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Homyel’skaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Rasony",
      "lat": "55.9058",
      "lng": "28.8135",
      "country": "Belarus",
      "iso2": "BY",
      "admin_name": "Vitsyebskaya Voblasts’",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    }
  ]
}
